<template>
  <EstimatedDeliveryStatsKpi
    :is-visible="true"
    :label="$t('names.site', siteCount || 2)"
    :value="siteCount ? formatNumber(siteCount, '0,0') : DASH"
    :icon="iconColoredSite"
    :is-loading="isLoading"
    trend-format="+0a"
    data-entity-type="siteCount"
    :show-tooltip="false">
  </EstimatedDeliveryStatsKpi>
</template>

<script setup lang="ts">
  import { markRaw } from 'vue';

  import EstimatedDeliveryStatsKpi from '@/common/components/estimated-delivery-stats/EstimatedDeliveryStatsKpi.vue';
  import { IconColoredSite } from '@/common/icons/colored';
  import { DASH } from '@/globals';
  import formatNumber from '@/utils/NumberFormatter';

  const iconColoredSite = markRaw(IconColoredSite);

  interface IEstimatedDeliveryStatsKpiImpressionsProps {
    siteCount?: number;
    isLoading: boolean;
  }
  const props = defineProps<IEstimatedDeliveryStatsKpiImpressionsProps>();
</script>
